import reports from './reports';

export default { reports };
